import React, { useState, useEffect, useContext } from "react";
import { UserInformationContext, C4FStatusContext, InfoModalContext } from "./App";
import C4FChat from '../common/C4FChat';
import config from "../etc/config.json";
import { Button, ButtonGroup, Row, Col, Container } from 'react-bootstrap';
import C4FSimpleTable from "../common/C4FSimpleTable";

function Chat(props) {
  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const { showTeamInfo } = useContext(InfoModalContext);
  const [fairplayStatistics, setFairplayStatistics] = useState([]);
  const [tab, setTab] = useState('chat');

  function handleMainTab(tab) {
    setTab(tab)
    if (tab === 'fairplay' && fairplayStatistics.length === 0)
      loadStatistics('fairplay');
  }

  function handleShowFromTeamInfo(fairplayRecord) {
    showTeamInfo({ teamId: fairplayRecord.fromTeamId, teamName: fairplayRecord.fromTeam });
  }
  function handleShowToTeamInfo(fairplayRecord) {
    showTeamInfo({ teamId: fairplayRecord.toTeamId, teamName: fairplayRecord.toTeam });
  }

  function loadStatistics(type) {
    handleBackendRequest('GET', '/statistics/' + type, null, null, setFairplayStatistics);
  }

  useEffect(() => {
    handleMainTab('chat');
  }, []);

  return <div className="container-fluid m-0 p-0 justify-content-center">
    <Row className="justify-content-center my-2">
      <ButtonGroup>
        <Button variant={(tab === 'chat') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('chat')}>Chat</Button>
        <Button variant={(tab === 'fairplay') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('fairplay')}>Fairplay</Button>
      </ButtonGroup>
    </Row>
    {(() => {
      if (tab === 'chat')
        return <Container fluid className="m-0 p-0 justify-content-center">
          <Row className="d-flex mt-1 p-1 justify-content-center">
            <Col className="ml-2 mr-1 my-1 p-0 justify-content-center" style={{ textAlign: "left", maxWidth: "80vw" }}>
              <h5>General Chat</h5>
              <p>The general chat can be used for all sorts of comments, questions and answers. Please respect fairplay in the chat. Insults and other offenses can lead to fines and bans. If you want to report a bug, please use the <a href={config.FORUM_BASE_URL + 'viewforum.php?f=5'} target="_blank" rel="noreferrer">Bugs-Section</a> in the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> instead.</p>
            </Col>
          </Row>
          <Row className="d-flex mt-1 p-1 justify-content-center">
            <Col className="border border-secondary" style={{ minWidth: 400, backgroundColor: 'rgba(255, 255, 255, 1)' }}>
              <C4FChat height="1000" mode="readwrite" type="general" chat="" user={userInformation.userName} />
            </Col>
          </Row>
        </Container>
      if (tab === 'fairplay')
        return <div className="container-fluid m-0 p-0 justify-content-center">
          <Row className="d-flex mt-1 p-1 justify-content-center">
            <Col className="ml-2 mr-1 my-1 p-0 justify-content-center" style={{ textAlign: "left", maxWidth: "80vw" }}>
              <h5>Fairplay</h5>
              <p>The table shows recent fairplay votings.</p>
            </Col>
          </Row>
          <Row className="d-flex mt-1 p-1 justify-content-center">
            <Col className="ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <h5>Fairplay Votings</h5>
              <div className="m-0 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                <Container className="c4f-stats">
                  <Row className="c4f-stats ">
                    <C4FSimpleTable key={'fairplay'}
                      initialSortingColumn={'date'}
                      initialSortingAscending={false}
                      data={fairplayStatistics}
                      rowMetadata={[
                        { columnName: 'date', columnDescription: 'Date' },
                        { columnName: 'fromTeam', columnDescription: 'From', cellClickEvent: handleShowFromTeamInfo },
                        { columnName: 'toTeam', columnDescription: 'To', cellClickEvent: handleShowToTeamInfo },
                        { columnName: 'points', columnDescription: 'Vote', columnType: 'fairplayVote' },
                        { columnName: 'message', columnDescription: 'Message' }
                      ]} />
                  </Row>
                </Container>

              </div>
            </Col>
          </Row>
        </div>
    })()}
    <Row className="d-flex p-0 m-1 justify-content-center">
      <Col style={{ textAlign: "center" }}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Visit the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> for more discussions.</p>
        <br />
        <br />
        <br />
      </Col>
    </Row>
  </div>
}

export default Chat;